export function formatRoundedYAxisTick(value: unknown): string {
  const numberValue = Number(value);

  if (!Number.isFinite(numberValue)) {
    return '';
  }

  return Math.round(numberValue).toString();
}

export function formatRoundedLiterValue(value: unknown): string {
  const roundedValue = formatRoundedYAxisTick(value);

  return roundedValue ? `${roundedValue} l` : '';
}
